import { Typography } from "@material-ui/core";
import PropTypes from "prop-types";

export const ErrorComponent = ({ error }) => {
    return (
        <>
            <Typography variant="h6">Something went wrong...</Typography>
            <br />
            {error.errorCode}-{error.message}
        </>
    );
};

ErrorComponent.propTypes = {
    error: PropTypes.shape({
        errorCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        message: PropTypes.string,
    }),
};
